<template>
  <div class="progress-bar-wrapper">
    <div class="progress-bar-background">
      <div
        class="progress-bar-fill"
        :style="{
          width: percent + '%',
          backgroundColor: progressColor,
        }"
      ></div>
    </div>
    <span class="progress-label">%{{ percent }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  percent: {
    type: Number,
    required: true,
    default: 0,
  },
});

const progressColor = computed(() => {
  if (props.percent >= 85) {
    return '#FF8EF4';
  } else if (props.percent >= 21) {
    return '#4FA4E5';
  } else {
    return '#FF3939';
  }
});
</script>

<style scoped>
.progress-bar-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
}

.progress-bar-background {
  width: 100%;
  height: 6px;
  background-color: #eee;
  border-radius: 32px;
  overflow: hidden;
  flex: 1;
}

.progress-bar-fill {
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 32px;
}

.progress-label {
  min-width: 31px;
  height: 16px;
  font-weight: bold;
}
</style>
